import React, { useEffect, useState, useRef } from 'react';
import Header from './components/Header';
import { initKakao } from './utils/kakaoInit';
import HeroSection from './components/HeroSection';
import OnboardingSection from './components/OnboardingSection';
import MapSection from './components/MapSection';
import PreRegistrationSection from './components/PreRegistrationSection';
import ServiceIntroSection from './components/ServiceIntroSection';
import Footer from './components/Footer';
import SurveyDialog from './components/SurveyDialog';

const STORE_URLS = {
  IOS: 'https://apps.apple.com/kr/app/%EB%96%A0%EB%A6%AC-%EB%B2%A0%EC%9D%B4%EC%BB%A4%EB%A6%AC-%EB%A7%88%EA%B0%90%ED%95%A0%EC%9D%B8/id6742439407?l=en-GB',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.thurry.thurry'
};

function App() {
  // 설문 모달 비활성화
  const [showSurvey] = useState(false);
  const [hasSeenSurvey] = useState(true);
  const [price, setPrice] = useState(6900);
  const [isVisible, setIsVisible] = useState(false);
  const [showFinalPrice, setShowFinalPrice] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  // 기기 타입 감지
  const detectDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    
    if (isIOS) return STORE_URLS.IOS;
    if (isAndroid) return STORE_URLS.ANDROID;
    return STORE_URLS.IOS; // 데스크톱의 경우 기본값으로 iOS 스토어
  };

  useEffect(() => {
    // Smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    // Initialize Kakao SDK
    initKakao();
  }, []);

  const handleServiceIntroVisibility = (visible: boolean) => {
    if (visible && !isVisible) {
      setIsVisible(true);
      setTimeout(() => {
      // 애니메이션 시작
      let startPrice = 6900;
      const endPrice = 990;
      const duration = 2000; // 2초
      const steps = 60; // 60프레임
      const stepDuration = duration / steps;
      const priceStep = (startPrice - endPrice) / steps;

      const timer = setInterval(() => {
        startPrice -= priceStep;
        if (startPrice <= endPrice) {
          setPrice(endPrice);
          clearInterval(timer);
          setTimeout(() => setShowFinalPrice(true), 200);
        } else {
          setPrice(Math.round(startPrice));
        }
      }, stepDuration);
      }, 3000); // 5초 딜레이
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <OnboardingSection />
      <MapSection />
      <PreRegistrationSection />
      <ServiceIntroSection onVisibilityChange={handleServiceIntroVisibility} />
      <Footer />
      
      {/* Fixed Bottom Button */}
      <div ref={buttonRef} className="fixed bottom-0 left-0 right-0 p-4 bg-white/95 backdrop-blur-sm border-t border-gray-100">
        <div className="max-w-xl mx-auto">
          <button 
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 px-6 rounded-xl text-lg font-bold hover:from-orange-600 hover:to-orange-700 transition-all transform hover:scale-[1.02] active:scale-[0.98]"
            onClick={() => window.open(detectDevice(), '_blank')}
          >
            <div className="flex items-center justify-center gap-2">
              <span>지금 가입하면 떠리패스가</span>
              {!isVisible ? (
                <span className="min-w-[4ch]">???</span>
              ) : (
                <span className={`transition-all duration-300 ${showFinalPrice ? 'scale-110' : ''}`}>
                  <span>{price.toLocaleString()}</span>
                  <span>원</span>
                  {showFinalPrice && <span>!</span>}
                </span>
              )}
            </div>
          </button>
        </div>
      </div>

      {/* Survey Dialog - 현재 비활성화 */}
      <SurveyDialog 
        isOpen={false} 
        onClose={() => {}} 
      />
    </div>
  );
}

export default App;